// extracted by mini-css-extract-plugin
export default {"main":"fee-pay-modal_main__1g7Cv"};